export default __webpack_public_path__ + "static/media/Priyansha.4b204c4f.jpeg";